/* unplugin-vue-components disabled */import script from "./BookingBasicInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingBasicInfo.vue?vue&type=script&setup=true&lang=js"

import "./BookingBasicInfo.vue?vue&type=style&index=0&id=4beb98f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4beb98f3"]])

export default __exports__